<template>
    <div class="leaflet">
        <table class="table product-detail__table table-hover" data-cy="product-detail-table">
            <tbody>
                <tr v-for="(item, id) in info" :key="id">
                    <td class="fwb text-nowrap">{{ item.title }}</td>
                    <td class="text-right">
                        <a v-if="item.linkType === 'file'" :href="item.link" :download="item.name" target="_blank" data-cy="leaflet">{{
                            item.name
                        }}</a>
                        <nuxt-link v-else-if="item.linkType === 'brand'" :to="brand.shopUrlPath">{{ item.name }}</nuxt-link>
                        <a v-else-if="item.linkType === 'router'" :href="item.link">{{ item.name }}</a>
                        <a
                            v-for="propertyOptionLink in item.propertyOptionLinks"
                            v-else-if="item.propertyOptionLinks?.length"
                            :key="propertyOptionLink.name"
                            :href="propertyOptionLink.fullPath"
                        >
                            &nbsp;{{ propertyOptionLink.name }}
                        </a>
                        <span v-else data-cy-element="product-detail-info-table-row" :data-cy-label="item.title">{{ item.name }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts">
import AdditionalInformation from '~/models/Product/AdditionalInformation'

export default {
    props: {
        info: {
            type: Array as PropType<AdditionalInformation[]>,
            default: () => [],
        },
        brand: {
            type: Object as any,
            default: () => {},
        },
    },
}
</script>

<style lang="scss" scoped>
.leaflet {
    overflow: auto;
    margin-top: 1.5rem;

    .product-detail__table {
        a {
            display: block;

            @include screen-sm {
                display: inline-block;
            }
        }
    }
}
</style>
